<template>
  <div class="tw-inline-flex" role="group">
    <button
      type="button"
      class="tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-px-2 tw-text-sm tw-font-medium tw-text-primary-grey-200 hover:tw-text-primary-grey-700 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-primary-grey-100/80 disabled:tw-text-primary-grey-200"
      :disabled="disabled || !canPreviousPage"
      :data-test-id="`${props.testId}-previous`"
      @click="previousPage"
    >
      <span class="tw-sr-only">"Previous Page"</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-chevron-left"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M15 6l-6 6l6 6"></path>
      </svg>
    </button>
    <button
      type="button"
      class="tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-primary-grey-500 tw-px-2 tw-text-sm tw-font-medium tw-text-primary-grey-200 hover:tw-text-primary-grey-700 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-primary-grey-100/80 disabled:tw-text-primary-grey-200"
      :disabled="disabled || !canNextPage"
      :data-test-id="`${props.testId}-next`"
      @click="nextPage"
    >
      <span class="tw-sr-only">"Next Page"</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-chevron-right"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M9 6l6 6l-6 6"></path>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

export type Props = {
  canPreviousPage: boolean;
  previousPage: () => void;
  canNextPage: boolean;
  nextPage: () => void;
  disabled?: boolean;
  testId?: string;
};

const props = withDefaults(defineProps<Props>(), {
  testId: "cl-table-basic-pagination",
});

const { canPreviousPage, previousPage, canNextPage, nextPage, disabled } =
  toRefs(props);
</script>
